import React from 'react';
import Link from '@material-ui/core/Link';
import { withStyles } from '@material-ui/core/styles';
import MobileDetect from 'mobile-detect';

const PublicFooter = ({ classes }) => {
  const md = new MobileDetect(window.navigator.userAgent);
  const isMobile = md.mobile();

  return isMobile ? null : (
  <footer className={classes.footer}>
    <div className={classes.container}>
      <div className={classes.row}>
        <span className={classes.item}>
          <b>
            {/* Get in Touch:{' '}info@qwell.com */}
            {/* <Link href="mailto:info@qwell.com" className={classes.link}>
              info@qwell.com
            </Link> */}
            Get in Touch: {' '}
            <Link href="https://qwell.com/for-providers/?formType=Get in touch#contactForm" className={classes.link}>info@qwell.com</Link>
          </b>
        </span>{' '}
        |
        <span className={classes.item}>
          <b>
            Media Inquiries:{' '}
            <Link href="https://qwell.com/for-providers/?formType=Media Inquires#contactForm" className={classes.link}>concierge@qwell.com</Link>
          </b>
        </span>
      </div>

      <div className={classes.row}>
        <span className={classes.item}>
          <b>
            <Link
              href={
                process.env.REACT_APP_HOMEPAGE_URL + '/patient-terms-of-use/'
              }
              className={classes.link}
            >
              Terms of Use for Patients
            </Link>
          </b>
        </span>{' '}
        |
        <span className={classes.item}>
          <b>
            <Link
              href={
                process.env.REACT_APP_HOMEPAGE_URL + '/provider-user-agreement/'
              }
              className={classes.link}
            >
              Terms of Use for Providers
            </Link>
          </b>
        </span>{' '}
        |
        <span className={classes.item}>
          <b>
            <Link
              href={process.env.REACT_APP_HOMEPAGE_URL + '/privacy-policy/'}
              className={classes.link}
            >
              Privacy Policy
            </Link>
          </b>
        </span>
      </div>

      <div className={classes.row}>
        <span>
          © {new Date().getFullYear()}, Qwell, LLC. All Rights Reserved.
        </span>
      </div>
    </div>
  </footer>
)};

const styles = () => ({
  footer: {
    backgroundColor: '#0277bd',
    color: 'white',
    fontSize: '14px',
    display: 'flex',
    justifyContent: 'center',
    padding: '15px 0',
    textDecoration: 'none',
    width: '100%',
    '@media only screen and (max-width: 1024px)': {
      textAlign: 'center',
    },
  },
  container: {
    width: '1080px',
  },
  row: {
    padding: '0.3em 0',
  },
  item: {
    paddingLeft: '0.2em',
  },
  link: {
    color: 'white',
    '&:hover': {
      opacity: '0.7',
      textDecoration: 'none',
    },
    '&:visited': {
      color: 'white',
    },
  },
});

export default withStyles(styles)(PublicFooter);
